import { styled } from '../../../../../../theme/styled';

export const TextAreaRoot = styled('div', {
  name: 'TextArea',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
